import { computed } from 'vue';

import { SKU_COLLAPSE_STYLE, SKU_STYLE_TYPE } from '@/store/constants';
import { clarifyObject } from '@/utils/objectHelper';

export const useProductStyle = (computedComponents: any) => {
  const productNameStyle = computed(() => clarifyObject({
    fontSize: computedComponents.value?.name?.textSize,
    lineHeight: computedComponents.value?.name?.lineHeight,
    color: computedComponents.value?.name?.textColor,
  }));

  const productPriceStyle = computed(() => clarifyObject({
    fontSize: computedComponents.value?.price?.textSize,
    lineHeight: computedComponents.value?.price?.lineHeight,
    color: computedComponents.value?.price?.textColor,
  }));

  const productButtonStyle = computed(() => {
    if (computedComponents.value?.button?.fillStyle === 'solid') {
      return clarifyObject({
        fontSize: computedComponents.value?.button?.textSize,
        lineHeight: computedComponents.value?.button?.lineHeight,
        // For CSS 的 hover 使用
        '--custom_product_button_color': 'white',
        '--custom_product_button_bg_color': computedComponents.value?.button?.textColor,
        '--custom_product_button_color_hover': 'white',
        '--custom_product_button_bg_color_hover': computedComponents.value?.button?.textColor,
        '--custom_product_button_opacity': 1,
        '--custom_product_button_opacity_hover': 0.7,
        '--custom_product_button_border_color': computedComponents.value?.button?.textColor,
      });
    }
    return clarifyObject({
      fontSize: computedComponents.value?.button?.textSize,
      lineHeight: computedComponents.value?.button?.lineHeight,
      // For CSS 的 hover 使用
      '--custom_product_button_color': computedComponents.value?.button?.textColor,
      '--custom_product_button_bg_color': 'white',
      '--custom_product_button_color_hover': 'white',
      '--custom_product_button_bg_color_hover': computedComponents.value?.button?.textColor,
      '--custom_product_button_opacity': 1,
      '--custom_product_button_opacity_hover': 1,
      '--custom_product_button_border_color': computedComponents.value?.button?.textColor,
    });
  });

  // NOTE: The return value will apply to @/components/Product/Product.scss
  // Do NOT replace it with SKU_COLLAPSE_STYLE
  const skuImageStyle = computed(() => {
    if (computedComponents.value?.skuStyle?.type === SKU_STYLE_TYPE.EXPAND) {
      return 'square';
    }

    if (computedComponents.value?.skuStyle?.collapseStyle === SKU_COLLAPSE_STYLE.CIRCLE) {
      return 'circle';
    } else if (computedComponents.value?.skuStyle?.collapseStyle === SKU_COLLAPSE_STYLE.HIDDEN) {
      return 'hidden';
    } else {
      return 'square';
    }
  });

  return {
    productNameStyle,
    productPriceStyle,
    productButtonStyle,
    skuImageStyle,
  };
};
